import { Tag, forwardRef, type TagProps } from '@chakra-ui/react';
import { type ReactNode } from 'react';

interface Props extends TagProps {
  children: ReactNode;
}

export const ShowAdditionalFilterTagsButton = forwardRef<Props, 'div'>(
  ({ children, ...tagProps }, ref) => {
    return (
      <Tag
        ref={ref}
        as='button'
        layerStyle='CollectionTag'
        borderRadius='full'
        {...tagProps}
      >
        {children}
      </Tag>
    );
  },
);
